export enum NotificationDelay {
  SHORT = 2000,
  DEFAULT = 4000,
  LONG = 7000,
}
